import { ProductEnum } from '@core/interfaces/common.interfaces';
import {
	IRouteBaseDefinition,
	RouteBasePathEnum
}                      from '@core/interfaces/route.interface';


export enum TenantConsoleRoutesEnum {
	USAGE_PAGE = 'usage/:product/:usagePeriod',
	SIGNATURES_PAGE = 'signatures',
	STATISTICS_PAGE = 'statistics'
}

export interface TenantConsoleStatisticsPageRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.TenantConsole;
	path: TenantConsoleRoutesEnum.STATISTICS_PAGE;
}

export interface TenantConsoleTransactionsPageRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.TenantConsole;
	path: TenantConsoleRoutesEnum.SIGNATURES_PAGE;
}

export interface TenantConsoleUsagePageRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.TenantConsole;
	path: TenantConsoleRoutesEnum.USAGE_PAGE;
	params: {
		product: ProductEnum,
		usagePeriod: string
	};
}
